import { LinkProps } from '@mui/material';
import { colors } from './colors';
import MUILink from '../../../../components/link';

export const components = {
    MuiDivider: {
        styleOverrides: {
            root: {
                borderColor: colors.grey3,
                marginTop: '4px',
                marginBottom: '4px',
            },
        },
    },
    MuiLink: {
        defaultProps: {
            component: MUILink,
        } as LinkProps,
    },
    MuiMenu: {
        styleOverrides: {
            paper: {
                boxShadow: '2px 9px 5.5px 0px rgba(159, 158, 158, 0.15)',
            },
        },
    },
    MuiMenuItem: {
        styleOverrides: {
            root: {
                paddingTop: '12px',
                paddingBottom: '12px',
                marginTop: '4px',
            },
        },
    },
    MuiList: {
        styleOverrides: {
            root: {
                padding: 0,
            },
        },
    },
    MuiBackdrop: {
        styleOverrides: {
            root: {
                backgroundColor: 'transparent',
            },
        },
    },
    MuiDrawer: {
        styleOverrides: {
            paper: {
                boxShadow: 'none',
            },
        },
    },
    MuiListItemIcon: {
        styleOverrides: {
            root: {
                minWidth: '35px',
            },
        },
    },
    MuiListItemButton: {
        styleOverrides: {
            root: {
                margin: '20px 12px 0',
                padding: '8px 14px',
                borderRadius: '4px',
            },
        },
    },
    MuiTableCell: {
        styleOverrides: {
            head: {
                fontSize: '12px',
                fontWeight: 600,
                lineHeight: '16px',
                backgroundColor: colors.white,
            },
            root: {
                height: '48px',
                fontSize: '14px',
                fontWeight: 400,
                lineHeight: '20px',
                backgroundColor: colors.white,
            },
        },
    },
    MuiPaper: {
        styleOverrides: {
            root: {
                boxShadow: 'none',
                borderRadius: '8px',
            },
        },
    },
    MuiTablePagination: {
        styleOverrides: {
            root: {
                '&:last-child': {
                    padding: '16px 0 8px',
                },
                '@media (max-width: 600px)': {
                    '& .MuiInputBase-root': {
                        marginRight: '8px',
                    },
                    '& .MuiToolbar-root .MuiTablePagination-actions': {
                        marginLeft: '3px',
                    },
                },
            },
            selectLabel: {
                fontSize: '12px',
                fontWeight: 400,
                letterSpacing: '0.4px',
                color: colors.grey1,
                paddingBottom: '2px',
            },
            displayedRows: {
                fontSize: '12px',
                fontWeight: 400,
                letterSpacing: '0.4px',
            },
            select: {
                fontSize: '12px',
                fontWeight: 400,
                letterSpacing: '0.4px',
            },
            actions: {
                fontSize: '12px',
                fontWeight: 400,
                letterSpacing: '0.4px',
            },
            menuItem: {
                fontSize: '12px',
                fontWeight: 400,
                letterSpacing: '0.4px',
                lineHeight: '16px',
                padding: '8px',
            },
        },
    },
    MuiInputLabel: {
        styleOverrides: {
            root: {
                fontSize: 14,
                color: colors.grey1,
                backgroundColor: colors.white,
                top: '-2px'
            },
            shrink: {
                top: '2px'
            }
        },
    },
    MuiOutlinedInput: {
        styleOverrides: {
            root: {
                height: '56px',
                '& fieldset': {
                    borderColor: colors.grey2,
                    borderWidth: '1px',
                },
                '&:hover fieldset': {
                    borderColor: colors.grey2,
                },
                '&.Mui-focused fieldset': {
                    borderWidth: '1px',
                    borderColor: colors.grey2,
                },
                '&.Mui-error fieldset': {
                    borderColor: colors.system.error.main,
                },
            },
        },
    },
};
